
import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../options/header"

const starter = '/cases'


export default {
    getAll() {
      try {
        return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + starter+'/file/tags', {
          params: {},
           credentials: true
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },


    getCaseFileTags(case_id) {
      try {
        return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + starter+"/case/"+case_id+"/file/tags", {
          params: {},
           credentials: true
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },

    upsert(case_id, fileList, spis) {
      try {
        return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + starter+"/case/"+case_id+"/file/tags", {
          params: {
            fileList,
            spis
          },
           credentials: true
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },

}